// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__PgUGo","content":"styles_content__LQHrT","row":"styles_row__CyjQ8"};